<template>
  <div class="watermark" v-if="visible" ref="watermark"></div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'rgba(200, 200, 200, 0.20)'
    },
    fontSize: {
      type: Number,
      default: 20
    },
    fontWeight: {
      type: String,
      default: '300'
    },
    visible: {
      type: Boolean,
      default: true
    },
    rotate: {
      type: Number,
      default: -22
    },
    gap: {
      type: Number,
      default: 60
    },
    zIndex: {
      type: Number,
      default: 9
    }
  },
  mounted() {
    this.addWatermark(this.content);
  },
  watch: {
    content(newVal) {
      if (newVal) {
        this.addWatermark(newVal);
      }
    }
  },
  methods: {
    addWatermark(text) {
      const watermarkDiv = this.$refs.watermark;
      const textLen = this.getStrLen(text);
      const canvas = document.createElement('canvas');
      canvas.width = textLen / 2 * this.fontSize + this.gap;
      canvas.height = this.gap * 1.5 + this.fontSize;

      const ctx = canvas.getContext('2d');
      ctx.font = this.fontWeight + ' ' + this.fontSize + 'px Arial';
      ctx.fillStyle = this.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.rotate(this.rotate * Math.PI / 180);
      ctx.fillText(text, canvas.width / 2 - this.gap / 2, canvas.height - this.fontSize / 2);

      watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
      watermarkDiv.style.pointerEvents = 'none';
      watermarkDiv.style.position = 'fixed';
      watermarkDiv.style.top = 0;
      watermarkDiv.style.left = 0;
      watermarkDiv.style.width = '100%';
      watermarkDiv.style.height = '100%';
      watermarkDiv.style.zIndex = this.zIndex;
    },

    // 计算字符串长度(英文占1个字符，中文汉字占2个字符) 把双字节的替换成两个单字节的然后再获得长度
    getStrLen(str) {
      if (str == null || str == undefined) return 0;
      if (typeof str != "string") {
        str += "";
      }
      return str.replace(/[^\x00-\xff]/g, "01").length;
    },

  }
}
</script>

<style scoped>
.watermark {
  background-repeat: repeat;
}
</style>
